exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*[data-v-686ba2b8] {\n  will-change: height;\n  -webkit-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  transform: translateZ(0);\n  backface-visibility: hidden;\n  perspective: 1000px;\n}\n", ""]);

// exports
